<script>
import axios from "axios";

import i18n from "../i18n";
import { Component, Mixins, Vue } from "vue-property-decorator";
import { AuthModule } from "@/store/modules/auth.module";
import { NotificationsModule } from "@/store/modules/notification.module";
import { settingsComputed } from "@/store/helper";
import { SettingModule } from "@/store/modules/settings.module";
import navBarMachine from "./machines/navBarMachine";
import Loader from "@/components/widgets/loader.vue";
import ClockWorkMini from "@/components/clockWork/clockworkMini.vue";
import { PAReviewModule } from "@/store/modules/paReview.module";

import { RightsConstant } from "@/store/securityRightConstant";
import { hasRight } from "@/store/helper";

import { interpret } from "xstate";
import simplebar from "simplebar-vue";
import * as signalR from "@microsoft/signalr";
import { bus } from "@/main";

import { VUE_APP_APP_NC_HUB_URL } from "@/services/config";
import { Constant } from "@/store/constant";

/**
 * Nav-bar Component
 */
export default {
    data() {
        return {
            languages: [
                {
                    //flag: require("@/assets/images/flags/us.jpg"),
                    language: "en",
                    title: "English",
                },
                {
                    //flag: require("@/assets/images/flags/french.jpg"),
                    language: "fr",
                    title: "French",
                },
                {
                    //flag: require("@/assets/images/flags/spain.jpg"),
                    language: "es",
                    title: "Spanish",
                },
                {
                    //flag: require("@/assets/images/flags/chaina.png"),
                    language: "zh",
                    title: "Chinese",
                },
                {
                    //flag: require("@/assets/images/flags/arabic.png"),
                    language: "ar",
                    title: "Arabic",
                },
            ],
            lan: i18n.locale,
            text: null,
            flag: null,
            value: null,
            fullName: AuthModule.fullName,
            showNotificationcard: false,
            machine: null,
            machineService: null,
            state: null,
            connection: null,
            accessKey: null,
            userId: null,
        };
    },

    components: { simplebar, Loader, ClockWorkMini },
    mounted() {
        this.value = this.languages.find((x) => x.language === i18n.locale);
        this.text = this.value.title;
        this.flag = this.value.flag;
        //const expiresOn = AuthModule.expiredOn;
        //const diffInMilliseconds = expiresOn.getTime() - new Date().getTime();

        //const expiresInMinutes = Math.round(((diffInMilliseconds % 86400000) % 3600000) / 60000);
        ////alert(expiresInMinutes);
        //if (expiresInMinutes <= 0) {
        //    //alert(expiresInMinutes);
        //    this.$router.push({ path: '/sessiontimeout' });
        //}
    },
    computed: {
        ...settingsComputed,

        notifications() {
            return NotificationsModule.notificationDetails;
        },

        notificationCount() {
            return NotificationsModule.notificationCount;
        },
        // userIdValue() {
        //     return AuthModule.userIdValue;
        // },

        notificationTypes() {
            return Constant.NotificationTypes;
        },

        rightsConstant() {
            return RightsConstant;
        },
        rightsHelper() {
            return hasRight;
        },
        tenantLogo() {
            return SettingModule.userProfile.tenantLogoUrl;
        },
        // The API always returns a URL. With no upload that URL is the shared user-default.svg.
        hasProfileImage() {
            const value = ((this.userProfile && this.userProfile.profileImageUrl) || "").trim();
            return !!value && value.toLowerCase().indexOf("user-default.svg") === -1;
        },
    },

    methods: {
        toggleMenu() {
            this.$parent.toggleMenu();
        },
        toggleRightSidebar() {
            this.$parent.toggleRightSidebar();
        },
        initFullScreen() {
            document.body.classList.toggle("fullscreen-enable");
            if (!document.fullscreenElement && /* alternative standard method */ !document.mozFullScreenElement && !document.webkitFullscreenElement) {
                // current working methods
                if (document.documentElement.requestFullscreen) {
                    document.documentElement.requestFullscreen();
                } else if (document.documentElement.mozRequestFullScreen) {
                    document.documentElement.mozRequestFullScreen();
                } else if (document.documentElement.webkitRequestFullscreen) {
                    document.documentElement.webkitRequestFullscreen(Element.ALLOW_KEYBOARD_INPUT);
                }
            } else {
                if (document.cancelFullScreen) {
                    document.cancelFullScreen();
                } else if (document.mozCancelFullScreen) {
                    document.mozCancelFullScreen();
                } else if (document.webkitCancelFullScreen) {
                    document.webkitCancelFullScreen();
                }
            }
        },
        dashBoard() {
            this.$router.push({ name: "DashBoard" });
        },
        setLanguage(locale, country, flag) {
            this.lan = locale;
            this.text = country;
            this.flag = flag;
            i18n.locale = locale;
        },
        showNotifications() {
            this.showNotificationcard = true;
            this.machineService.send({ type: "NOTIFICATION" });
        },

        UpdateIsSeen(id) {
            NotificationsModule.UpdateIsSeen(id).then((response) => {
                if (response) {
                    this.showNotificationcard = false;
                }
            });
        },
        goToNotification() {
            this.$router.push({ name: "Notification" });
            this.showNotificationcard = false;
        },
        logout() {
            AuthModule.Logout().then((response) => {
                localStorage.clear();
                //this.$router.push("/");
            });
        },
        goToOverView(notification) {
            const { typeId, notificationData } = notification;

            this.machineService.send({ type: "UPDATE_IS_ACTIVE", notificationId: notification.id });

            if (typeId === this.notificationTypes.ReviewNotification()) {
                PAReviewModule.SetOperatingStepId(notificationData.stepId);
                this.$router.push({ name: "ReviewListing" });
                return;
            }

            if (typeId === this.notificationTypes.ReviewMeetingNotification()) {
                const routeName = notificationData.isAdmin ? "CycleListing" : "ReviewListing";
                this.$router.push({ name: routeName });
                return;
            }

            if (typeId === this.notificationTypes.HostileTakeOverNotification()) {
                return;
            }

            if (typeId !== this.notificationTypes.SubProjectRequestId()) {
                this.$router.push({ name: "ProjectOverview", params: { projectId: notificationData.projectId } });
                this.showNotificationcard = false;
                return;
            }
        },

        AcceptRequest(notificationId, isAccept) {
            const currentRoute = this.$route.name;

            if (currentRoute === "Notification") {
                bus.$emit("showRequestTrackingModal", {
                    requestTrackingNotificationId: notificationId,
                    isAccept: isAccept,
                });
            } else {
                this.$router.push({ name: "Notification", params: { requestTrackingNotificationId: notificationId, isAccept: isAccept } });
            }
        },

        // async initializeSignalR() {
        //     this.userId = this.userIdValue;
        //     if (AuthModule.isAuthenticated && AuthModule.accessToken) {
        //         this.accessKey = `${AuthModule.accessToken}`;
        //     }
        //     const options = {
        //         accessTokenFactory: () => this.accessKey,
        //     };
        //     const apiUrl2 = VUE_APP_APP_NC_HUB_URL;
        //     this.connection = new signalR.HubConnectionBuilder()
        //         .withUrl(apiUrl2, options)
        //         .withAutomaticReconnect()
        //         .configureLogging(signalR.LogLevel.Information)
        //         .build();

        //     await this.connection
        //         .start()
        //         .then(() => {
        //             console.log("Connection extablished.");
        //         })
        //         .catch((err) => {
        //             document.write(err);
        //         });
        // },
    },

    created() {
        // await this.initializeSignalR();
        this.machine = navBarMachine;
        this.machineService = interpret(this.machine, { devTools: true });
        this.state = this.machine.initialState;
        this.machineService.start();
        this.machineService.onTransition((state) => {
            var previousState = this.state;
            this.state = state;
        });

        // if (this.connection.state === signalR.HubConnectionState.Connected) {
        //     console.log("Connection is started from Nav-Bar");
        // } else {
        //     console.log("Connection is not started from Nav-Bar");
        // }

        // Vue.nextTick(() => {
        //     this.connection.invoke("JoinGroup", this.userId).catch((err) => {
        //         console.error(err.toString());
        //     });
        // });

        // this.connection.on("notificationReceived", (count, userId) => {
        //     if (userId == this.userId) {
        //         NotificationsModule.SetNotification(count);
        //     }
        // });
    },
    destroyed() {
        // this.connection.invoke("LeaveGroup", this.userId).catch(function(err) {
        //     return console.error(err.toString());
        // });
        this.machineService.stop();
    },
};
</script>

<template>
    <header id="page-topbar">
        <div class="navbar-header">
            <div class="s1-d-flex">
                <!-- LOGO -->
                <div class="navbar-brand-box">
                    <a href="javascript:void(0)" @click="dashBoard" class="logo logo-dark">
                        <span class="logo-sm">
                            <img src="@/assets/images/logo.svg" alt height="22" />
                        </span>
                        <span class="logo-lg">
                            <img src="@/assets/images/logo-dark.png" alt height="17" />
                        </span>
                    </a>

                    <a href="javascript:void(0)" @click="dashBoard" class="logo logo-light">
                        <span class="logo-sm">
                            <img src="@/assets/images/logo-icon.svg" alt height="30" />
                        </span>
                        <span class="logo-lg">
                            <img src="@/assets/images/logo-ecsystemone.png" alt height="36" />
                        </span>
                    </a>
                </div>

                <button id="vertical-menu-btn" type="button" class="btn btn-sm px-3 font-size-16 header-item" @click="toggleMenu">
                    <i class="fa fa-fw fa-bars"></i>
                </button>

                <!-- Tenant Name -->
                <!-- <div class="d-v-center d-none d-sm-flex">
                    <h5 class="m-0 tenant-name d-v-center">
                        <span class="text-secondary fs-6 me-2">Tenant:</span>
                        <span>{{ tenant.name }}</span>
                    </h5>
                </div> -->
            </div>

            <div class="s1-d-flex ms-auto">
                <div class="cw-mini-wrapper position-relative ms-auto" v-if="rightsHelper(rightsConstant.Clockwork.BasicPrivilege())">
                    <ClockWorkMini :key="$route.path" v-if="$route.path != '/ClockWork'"></ClockWorkMini>
                </div>
                <div class="dropdown d-none d-lg-inline-block ms-2 me-3">
                    <button type="button" class="btn header-item noti-icon" @click="initFullScreen">
                        <i class="bx bx-fullscreen"></i>
                    </button>
                </div>

                <b-dropdown menu-class="dropdown-menu-lg p-0 dropdown-menu-end" toggle-class="header-item noti-icon" variant="black">
                    <template v-slot:button-content>
                        <a href="javascrpit:void(0)" @click="showNotifications">
                            <i class="bx bx-bell ms-2 me-3" :class="{ 'bx-tada': notificationCount > 0 }"></i>
                            <span class="badge bg-danger rounded-pill bell-icon" v-if="notificationCount > 0">{{ notificationCount }}</span>
                        </a>
                    </template>
                    <div v-if="showNotificationcard == true" @click="goToNotification">
                        <div class="p-3 border-bottom mb-2">
                            <h6 class="mb-0 fs-16">Notifications</h6>
                        </div>
                        <Loader :loading="state.matches('gettingNotifications')">
                            <div v-if="notifications.length > 0">
                                <!-- <div v-if="showNotificatio2ncard"> -->
                                <simplebar style="max-height: 535px">
                                    <div v-for="notification in notifications" :key="notification" class="nav-notification-list" :class="{ 'cursor-pointer': notification.typeId != notificationTypes.SubProjectRequestId() }"
                                        @click.stop="notification.typeId != notificationTypes.SubProjectRequestId() && goToOverView(notification)">
                                        <div class="d-v-center">
                                            <div class="me-3 header-profile-user ">
                                                <img :src="notification.notificationData.profileImageUrl" class="rounded-circle" />
                                            </div>
                                            <div class="notification-para">
                                                <p v-if="notification.typeId === notificationTypes.SubProjectRequestId()" class="mb-0 notification-para-flap">
                                                    <label class="mb-0 me-1 fw-500 gray-700">{{ notification.notificationData.userName }}</label>
                                                    <span class="gray-600">has requested to link</span> <span class="gray-700">{{ notification.notificationData.projectName }}</span>
                                                </p>
                                                <P v-else-if="notification.typeId === notificationTypes.AddProjectTeamMemberNotificationId()" class="mb-0 gray-600 notification-para-flap">
                                                    <label class="mb-0 me-1 fw-500 gray-700">{{ notification.notificationData.userName }}</label>
                                                    <span class="gray-600"> has added you to the</span> <span class="gray-700">{{ notification.notificationData.projectName }}</span> as a Team Member
                                                </P>
                                                <P v-else-if="notification.typeId === notificationTypes.ChangeOwnerShipNotificationId()" class="mb-0 gray-600 notification-para-flap">
                                                    <label class="mb-0 me-1 fw-500 gray-700">{{ notification.notificationData.userName }}</label>
                                                    <span class="gray-600"> has transferred the ownership of </span><span class="gray-700 fw-500">{{ notification.notificationData.projectName }}</span> to you
                                                </P>
                                                <P v-else-if="notification.typeId === notificationTypes.AcceptedLinkedProjectNotificationId()" class="mb-0 gray-600 notification-para-flap">
                                                    <label class="mb-0 me-1 fw-500 gray-700">{{ notification.notificationData.userName }}</label>
                                                    <span class="gray-600">has accepted your request for linking </span><span class="gray-700 fw-500">{{ notification.notificationData.projectName }}</span>
                                                </P>
                                                <P v-else-if="notification.typeId === notificationTypes.ConvertTaskToProjectNotificationId()" class="mb-0 gray-600 notification-para-flap">
                                                    <label class="mb-0 me-1 fw-500 gray-700">{{ notification.notificationData.taskName }}</label>
                                                    <span class="gray-600">has been converted to a Project with </span><span class="gray-700 fw-500">{{ notification.notificationData.projectOwnerName }} </span>as the
                                                    Project Owner.
                                                </P>
                                                <P v-else-if="notification.typeId === notificationTypes.ReviewNotification()" class="mb-0 gray-600 notification-para-flap">
                                                    <span class="gray-600">{{ notification.notificationData.notificationMessage }}</span>
                                                </P>
                                                <P v-else-if="notification.typeId === notificationTypes.ReviewMeetingNotification()" class="mb-0 gray-600 notification-para-flap">
                                                    <span class="gray-600">{{ notification.notificationData.messageData }}</span>
                                                </P>
                                                <P v-else-if="notification.typeId === notificationTypes.RequestedProjectRejectionNotification()" class="mb-0 gray-600 notification-para-flap">
                                                    <label class="mb-0 me-1 fw-500 gray-700">{{ notification.notificationData.userName }}</label>
                                                    <span class="gray-600">has rejected your request for linking </span><span class="gray-700 fw-500">{{ notification.notificationData.projectName }}</span>
                                                </P>
                                                <P v-else-if="notification.typeId === notificationTypes.HostileTakeOverNotification()" class="mb-0 gray-600 notification-para-flap">
                                                    <span class="gray-600">{{ notification.notificationData.value }}</span>
                                                </P>
                                            </div>
                                        </div>
                                        <div class="ms-5 d-flex-between">
                                            <p class="notification-time-format me-3 mb-0">
                                                <span class="align-middle gray-500">{{ notification.formattedTime() }}</span>
                                            </p>
                                            <div v-if="notification.typeId === notificationTypes.SubProjectRequestId() && !notification.isSeen" class="s1-d-flex">
                                                <button class="btn btn-outline-primary btn-sm notification-btn d-center me-2" @click="AcceptRequest(notification.id, true)">Accept</button>
                                                <button class="btn btn-outline-danger btn-sm notification-btn d-center" @click="AcceptRequest(notification.id, false)">Deny</button>
                                            </div>
                                        </div>
                                    </div>
                                </simplebar>
                            </div>
                            <div class="text-center notification-bell-icon" v-else>
                                <div class="d-center">
                                    <i class="bx bx-bell-off"></i>
                                </div>
                                <h6 class="fw-600 fs-16">
                                    No new notifications found.
                                </h6>
                                <!-- <p class="mb-0">
                                    you have currently no new notifications.
                                </p> -->
                                <p class="mb-3">
                                    We’ll notify you when something new arrives.
                                </p>
                                <button class="btn btn-sm btn-primary mb-2" @click="goToNotification">Notification Center</button>
                            </div>
                        </Loader>

                        <!-- </div> -->
                        <div class="p-2 border-top s1-d-flex mt-2" v-if="notifications.length > 0">
                            <a class="btn btn-sm btn-primary text-start" href="javascript:void(0)">
                                <span key="t-view-more" class="me-2 fs-12"> View All</span>
                                <i class="mdi mdi-arrow-right text-white me-1"></i>
                            </a>
                        </div>
                    </div>
                </b-dropdown>

                <!-- User account -->

                <div class="tenant-profile-info d-v-center">
                    <div class="brand-logo d-h-center">
                        <div class="brand-img d-h-center">
                            <img v-if="!tenantLogo" src="@/assets/images/default-logo.svg" />
                            <img v-else :src="tenantLogo" v-b-tooltip :title="tenant.name" />
                        </div>
                    </div>
                    <div class="d-v-center p-2">

                        <b-dropdown right variant="black" menu-class="dropdown-menu-end btn-avatar" toggle-class="header-item h-auto">
                            <template #button-content>
                                <div class="d-flex align-items-center">
                                    <div class="user-img">
                                        <img v-if="hasProfileImage" :src="userProfile.profileImageUrl" alt="" />
                                        <i v-else class="bx bx-user" aria-hidden="true"></i>
                                    </div>
                                    <i class="mdi mdi-chevron-down"></i>
                                </div>
                            </template>
                            <b-dropdown-item to="/profile" class="gray-600 navbar-user-profile">
                                <i class="bx bx-user  align-middle me-1"></i>
                                <span>Profile</span>
                            </b-dropdown-item>
                            <b-dropdown-item @click.stop="logout" href="#" class="navbar-user-profile gray-600">
                                <i class="bx bx-power-off  align-middle me-1 text-danger"></i>
                                {{ $t("navbar.dropdown.henry.list.logout") }}
                            </b-dropdown-item>
                        </b-dropdown>
                    </div>
                </div>
            </div>
        </div>
    </header>
</template>
